import { MyAccountContext } from 'contexts/providers/MyAccountProvider'
import { useContext } from 'react'

export const useMyAccount = () => useContext(MyAccountContext)
